import { useEffect } from "react";

const useScript = (url) => {
  useEffect(() => {
    const script = document.createElement("script");
    const interval = setInterval(() => {
      if (window.beamer_config) {
        script.src = url;
        script.async = true;
        script.defer = "defer";
        script.id = "beamer";

        document.body.appendChild(script);

        clearInterval(interval);
        const intervalInit = setInterval(() => {
          if (window.Beamer && window.beamer_config) {
            window.Beamer.init();
            clearInterval(intervalInit);
          }
        }, 2000);
      }
    }, 2000);

    return () => {
      if (window.Beamer) window?.Beamer?.destroy();
      window.beamer_config = null;
      try {
        const testScript = Array.from(
          document.querySelectorAll("script[id='beamer']")
        )?.[0];

        testScript?.parentNode?.removeChild(testScript);
      } catch (e) {}
    };
  }, [url]);
};

export default useScript;
// import { useEffect } from "react";

// const useScript = (url) => {
//   useEffect(() => {
//     const script = document.createElement("script");

//     script.src = url;
//     // script.async = true;
//     script.defer = "defer";

//     document.body.appendChild(script);

//     return () => {
//       document.body.removeChild(script);
//     };
//   }, [url]);
// };

// export default useScript;
